<template>
  <div class="page-container">
    <section class="mt-4 mb-10">
      <h1 class="font-size--24">신용인증 정보를 받아오고 있습니다.</h1>
      <h1 class="font-size--24">{{ content[index] }}</h1>
    </section>

    <!-- 로딩 이미지 -->
    <section>
      <v-layout justify-center class="pt-10">
        <v-progress-circular
          indeterminate
          :size="100"
          color="primary"
          :width="10"
        ></v-progress-circular>
      </v-layout>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { sleep } from '@/util'
export default {
  data() {
    return {
      index: 0,
      content: ['정보를 요청하고 있습니다.', '잠시만 기다려 주세요.', '확인하고 있습니다.'],
    }
  },
  async created() {
    _meta({
      titles: ['신용평가확인중'],
    })
    this.rotate()
    const { evid } = this.$route.query
    await sleep(3000)
    await this.evaluate(evid)
  },
  methods: {
    ...mapActions('evaluation', ['getCreditEvaluate']),
    rotate() {
      setTimeout(() => {
        this.index += 1
        if (this.index >= this.content.length) {
          this.index = 0
        }
        this.rotate()
      }, 1500)
    },
    async evaluate(uuid) {
      const data = await this.getCreditEvaluate({ uuid })
      if (data.isQualified === true) {
        const { redirectPath } = this.$route.query
        let url = '/factoring/success?'
        if (redirectPath) {
          console.log('******* factoring/evaluation, redirectPath=', redirectPath)
          // /loan/pull-revenue인 경우는 success로 보내지 않고 바로 이동
          if( decodeURIComponent(redirectPath).trim() ==='/loan/pull-revenue' ){
            return await this.$router.replace('/loan/pull-revenue')
          }


          url += `&redirectPath=${redirectPath}`
        }
        await this.$router.replace(url)
      } else {
        await this.$router.replace({
          name: 'factoring/failure',
          params: { title: data.title, reason: data.reason },
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__evaluation {
  .v-card {
    background-color: #f4faff;
  }
}
</style>
